import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppDispatch } from "Store/hooks";
import { Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setCurrentOrganization, setIsModalOpen } from "../redux/slice";
import { initialValues } from "../addEditOrganization/intialValues";
import { OrganizationConstants } from "Constants";
import "Features/Organizations/organization.index.css";

interface OrganizationToolbarProps {
  searchText: string;
  onSearchChange: (value: string) => void;
}

const OrganizationToolbar = ({ searchText, onSearchChange }: OrganizationToolbarProps) => {
  const dispatch = useAppDispatch();
  return (
    <div
    style={{justifyContent:"space-between", display: "flex", flexDirection: "row-reverse", margin: "5px",alignItems:'center' }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <Input
          placeholder="Search organizations..."
          prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
          allowClear
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{ width: 260 }}
        />
        <Button
          type="primary"
          className="add-organization-button"
          onClick={() => {
            dispatch(setCurrentOrganization(initialValues));
            dispatch(setIsModalOpen(true));
          }}
        >
          <FontAwesomeIcon style={{ marginRight: "10px" }} icon={faPlus} />
          {OrganizationConstants.ADD_ORGANIZATION}
        </Button>
      </div>
      <div className="organization-heading">Organizations</div>
    </div>
  );
};

export default OrganizationToolbar;
